






















































import {Component, Prop, Vue} from "vue-property-decorator";
import SelectSection from "@/components/billing_info/SelectSection.vue";

@Component({
    components:{
        SelectSection,
    }
})
export default class BillingInfoDisplay extends Vue {
    @Prop() public name!: string;
    @Prop() public kana!: string;
    @Prop() public companyName!: string;
    @Prop() public email!: string;
    @Prop() public emailCc1!: string;
    @Prop() public emailCc2!: string;
    @Prop() public emailCc3!: string;
    @Prop() public postCodeFirst!: string;
    @Prop() public postCodeLatter!: string;
    @Prop() public address!: string;
    @Prop() public buildingName!: string;
    @Prop() public departmentName!: string;
}
